import * as tslib_1 from "tslib";
import { SearchMaskActionTypes } from './types';
import { getSearchMaskBundleConfirmedAction, initSearchMaskModalAction, resetSearchMaskBundleToDefaultAction, } from '../../util/SearchMaskBundleMapper';
import UserInputValueToCoreMapper from '../../mapper/UserInputToCoreMapper';
export function setActiveTabSearchMask(activeTabType) {
    return {
        type: SearchMaskActionTypes.SEARCH_MASK_ACTIVE_TAB_CHANGE,
        searchMaskActiveTab: activeTabType
    };
}
export function resetSearchMaskToDefault(searchMaskRequestParam, lturState) {
    return {
        type: SearchMaskActionTypes.RESET_SEARCH_MASK_TO_DEFAULT_STATE,
        lturState: resetSearchMaskBundleToDefaultAction(searchMaskRequestParam, lturState)
    };
}
export function setSearchMaskConfirmed(searchMaskRequestParam, lturState) {
    var searchMaskRequestParamWithCoreQuery = tslib_1.__assign({}, searchMaskRequestParam, { searchMaskInput: tslib_1.__assign({}, searchMaskRequestParam.searchMaskInput, { coreQuery: UserInputValueToCoreMapper.mapQuery(searchMaskRequestParam.inputValueParam, searchMaskRequestParam.searchMaskGroupType, searchMaskRequestParam.searchMaskInput.type), coreOptions: UserInputValueToCoreMapper.mapOptions(searchMaskRequestParam.inputValueParam, searchMaskRequestParam.searchMaskGroupType, searchMaskRequestParam.searchMaskInput.type) }) });
    return {
        type: SearchMaskActionTypes.SET_SEARCH_MASK_CONFIRMED_STATE,
        lturState: getSearchMaskBundleConfirmedAction(searchMaskRequestParamWithCoreQuery, lturState),
    };
}
export function setSearchMaskBundle(searchMaskBundleParam) {
    return {
        type: SearchMaskActionTypes.SEARCH_MASK_BUNDLE_INIT,
        searchMaskBundle: searchMaskBundleParam,
    };
}
export function initSearchMaskModal(searchMaskModalRequest, lturState) {
    return {
        type: SearchMaskActionTypes.SEARCH_MASK_MODAL_INIT,
        lturState: initSearchMaskModalAction(searchMaskModalRequest, lturState)
    };
}
export function changeCalendarUI(searchMaskGroupTypeParam, travelPeriodUIValue) {
    return {
        travelPeriodUIValue: travelPeriodUIValue,
        type: SearchMaskActionTypes.CHANGE_CALENDAR_UI,
        searchMaskGroupType: searchMaskGroupTypeParam,
    };
}
export function closeCalendar(searchMaskGroupTypeParam) {
    return {
        type: SearchMaskActionTypes.CLOSE_CALENDAR,
        searchMaskGroupType: searchMaskGroupTypeParam
    };
}
export function changeCalendarInitFlow(searchMaskGroupTypeParam, triggerInitFlow) {
    return {
        triggerInitFlow: triggerInitFlow,
        type: SearchMaskActionTypes.CHANGE_CALENDAR_INIT_FLOW,
        searchMaskGroupType: searchMaskGroupTypeParam
    };
}
export function changeActiveDate(searchMaskGroupTypeParam, departureDateActive, returnDateActive) {
    return {
        departureDateActive: departureDateActive,
        returnDateActive: returnDateActive,
        type: SearchMaskActionTypes.CHANGE_ACTIVE_DATE,
        searchMaskGroupType: searchMaskGroupTypeParam,
    };
}
export function changeDurationUI(searchMaskGroupTypeParam, duration) {
    return {
        duration: duration,
        type: SearchMaskActionTypes.CHANGE_DURATION_UI,
        searchMaskGroupType: searchMaskGroupTypeParam,
    };
}
export function changeExactDuration(searchMaskGroupTypeParam, exactDurationParam) {
    return {
        exactDuration: exactDurationParam,
        type: SearchMaskActionTypes.CHANGE_EXACT_DURATION,
        searchMaskGroupType: searchMaskGroupTypeParam,
    };
}
export function changeShowErrorSearchMaskTravellers(searchMaskGroupTypeParam, showError) {
    return {
        showError: showError,
        type: SearchMaskActionTypes.CHANGE_SHOW_ERROR_TRAVELLERS,
        searchMaskGroupType: searchMaskGroupTypeParam
    };
}
export var setPagination = function (paginationObject, searchMaskGroupType) {
    return {
        searchMaskGroupType: searchMaskGroupType,
        type: SearchMaskActionTypes.SET_PAGINATION,
        pagination: paginationObject
    };
};
